<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4">
      <div class="d-flex align-center ga-2 text-light-blue-darken-4">
        <v-icon icon="mdi-square-edit-outline" size="20"></v-icon>
        <span class="font-weight-bold">Редагування в полях</span>
      </div>

      <div
        v-if="!readonly && documentAgreementCredentials.$hasChanges"
        class="d-flex ga-3">
        <v-btn variant="outlined" @click="cancelEdit">
          <v-icon icon="mdi-close" class="mr-1"></v-icon>
          <span>Скасувати</span>
        </v-btn>
        <v-btn
          color="black"
          :loading="$loading.isLoading('updateDocumentAgreement')"
          @click="updateDocumentAgreement">
          <v-icon icon="mdi-check" class="mr-1"></v-icon>
          <span>Зберегти</span>
        </v-btn>
      </div>
    </div>

    <v-row>
      <v-col cols="12" md="6">
        <b-input
          :model-value="documentAgreementSource.type?.name"
          hide-details
          readonly
          label="Тип документа"></b-input>
      </v-col>
      <v-col cols="12" md="6">
        <b-input
          :model-value="
            new CustomDate(documentAgreementSource.created_at).toString({
              time: true,
            })
          "
          hide-details
          readonly
          label="Дата створення"></b-input>
      </v-col>
      <v-col cols="12" md="6">
        <b-input
          v-model="documentAgreementCredentials.number"
          :readonly="readonly"
          hide-details
          label="Номер документа"
          placeholder="Напр.: 145/2026"></b-input>
      </v-col>
      <v-col cols="12" md="6">
        <b-input
          :model-value="getPersonName(documentAgreementSource.author)"
          readonly
          hide-details
          label="Автор"></b-input>
      </v-col>

      <v-col cols="12">
        <b-input
          v-model="documentAgreementCredentials.name"
          :readonly="readonly"
          hide-details
          label="Назва документа"></b-input>
      </v-col>
    </v-row>

    <v-divider class="my-5"></v-divider>

    <div class="d-flex align-center justify-space-between mb-3">
      <div class="font-weight-bold text-uppercase text-disabled">
        Контрагенти
      </div>
      <v-btn
        v-if="!readonly"
        variant="text"
        color="black"
        @click="addContractor">
        <v-icon icon="mdi-plus" class="mr-1"></v-icon>
        <span>Додати контрагента</span>
      </v-btn>
    </div>

    <v-row
      v-for="(contractor, index) in documentAgreementCredentials.contractors"
      :key="index">
      <v-col cols="8">
        <b-input
          v-if="contractor.documentAgreementContractorId"
          :model-value="contractor.name"
          readonly
          hide-details
          placeholder="Назва контрагента"></b-input>
        <b-autocomplete
          v-else
          :model-value="contractor.id"
          :items="$directory.get('contractors')"
          :item-title="c => `${c.name} (${c.code})`"
          :loading="$loading.isLoading('contractors')"
          item-value="id"
          hide-details
          placeholder="Назва контрагента"
          @update:model-value="
            id => onSelectContractor(index, id)
          "></b-autocomplete>
      </v-col>

      <v-col cols="4" class="d-flex align-center ga-3">
        <b-input
          :model-value="contractor.code"
          readonly
          hide-details
          class="w-100"
          placeholder="ЄДРПОУ"></b-input>

        <v-btn
          v-if="!readonly"
          color="error"
          variant="outlined"
          icon="mdi-trash-can-outline"
          density="comfortable"
          @click="removeContractor(index)"></v-btn>
      </v-col>
    </v-row>

    <div
      v-if="!documentAgreementCredentials.contractors?.length"
      class="text-disabled text-center py-3"
      style="border: 1px dashed #d5d5e0">
      Контрагентів не додано
    </div>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../documentAgreement'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { fillDirectory, getDirectory } from '@/directory'
import { onMounted } from 'vue'

export default {
  name: 'Requisites',
  methods: { getPersonName },
  setup() {
    const store = useDocumentAgreement()

    onMounted(() => {
      fillDirectory('contractors')
    })

    const onSelectContractor = (
      index: number,
      value: number | { id: number; name: string; code: string }
    ) => {
      const contractor =
        value && typeof value === 'object'
          ? value
          : (getDirectory('contractors') || []).find(c => c.id === value)
      if (contractor) {
        store.setContractor(index, contractor)
      }
    }

    return {
      ...store,
      onSelectContractor,
      CustomDate,
    }
  },
}
</script>

<style lang="scss" scoped></style>
